// src/helpers/fetchAndSetImagePath.js  
import { fetchImagePath } from '../api/selectedCompetition';

export const fetchAndSetImagePath = async (dispatch) => {
    try {
        const { imagePath, imagePathWhite } = await fetchImagePath();
        if (imagePath) {
            dispatch({ type: 'UPDATE_IMAGE_PATH', payload: { imagePath, imagePathWhite } });
        }
    } catch (error) {
        console.error('Error fetching image path:', error);
    }
};  
